export const UI = {
  es: {
    nav: { books: "Libros", manifesto: "Manifiesto", blog: "Bitácora", channels: "Canales Secretos", cta: "Contacto Cifrado", instagram: "Instagram" },
    hero: { overline: "Escritor · Clandestino · Cronista de la sombra", cta1: "Explorar la Obra", cta2: "Leer la Bitácora", scroll: "Desplazarse" },
    books: {
      overline: "Obras Publicadas", headingA: "Toda la", headingB: "Verdad",
      intro: "Los tres títulos de la saga ya están a la venta en Amazon, disponibles en todo el mundo. Escanea el código QR de cada libro y empieza a leer hoy.",
      amazon: "Comprar en Amazon", fragment: "Leer fragmento", synopsis: "Leer sinopsis completa",
      scanQr: "Escanea el código y compra en Amazon",
      reserved: "Espacio reservado", reservedSub: "Próxima publicación",
      modalTag: "Obra de Javier Alagrande", fragmentTag: "Fragmento · Lectura libre", synopsisTag: "Sinopsis · Lectura libre",
      edition: "Edición clandestina", sign: "J. Alagrande",
    },
    manifesto: {
      overline: "Manifiesto", headingA: "Escribir es un acto de", headingB: "resistencia",
      intro: "Tres capítulos, tres convicciones. Lo que este seudónimo defiende cada vez que la máquina de escribir se enciende a medianoche.",
    },
    blog: {
      overline: "Bitácora · Publicación quincenal", headingA: "Notas desde la", headingB: "Clandestinidad",
      intro: "Cada quince días, una entrada. Crónica, confesión o humo — siempre verdad a su manera.",
      readMore: "Leer artículo completo", archive: "Archivo 2026",
    },
    instagram: {
      overline: "Publicaciones diarias", headingA: "Instagram del", headingB: "Escritor",
      intro: "Cada día, un escrito nuevo: fragmentos, sentencias y notas desde la clandestinidad, publicados primero en Instagram.",
      follow: "Seguir a @alagrandejavier", placeholder: "Publicación diaria", placeholderSub: "El próximo escrito aparecerá aquí", view: "Ver en Instagram",
    },
    contact: {
      overline: "Canales Secretos · Buzón de Información", headingA: "Contacto", headingB: "Seguro",
      intro: "Si tienes información sensible, una historia que contar o simplemente palabras que no caben en público: este es el canal. Cifrado de extremo a extremo, sin intermediarios.",
      secure: "Transmisión cifrada · AES-256", subject: "Asunto", subjectPh: "Motivo de la comunicación…",
      message: "Mensaje encriptado", messagePh: "Escribe aquí. El contenido se cifrará antes de abandonar tu navegador…",
      anonA: "Enviar de forma", anonB: "100% anónima", anonSub: "Sin nombre, sin correo, sin identificadores. Sólo el mensaje.",
      submit: "Cifrar y enviar mensaje", encrypting: "Cifrando mensaje…",
      channelsTitle: "Direcciones y canales seguros", proton: "Correo cifrado · ProtonMail", telegram: "Canal de Telegram",
      pgp: "Clave pública PGP", copy: "Copiar clave",
      note: "Para información de máxima sensibilidad, prefiera Session o correo cifrado con PGP. Nunca incluya datos que puedan comprometer a terceros sin su consentimiento.",
      toastOk: "Mensaje cifrado y depositado en el buzón seguro.",
      toastOkAnon: "Enviado de forma 100% anónima. Sin rastro, sin registro de identidad.",
      toastOkNamed: "El autor responderá por el canal que indiques.",
      toastErr: "No se pudo entregar el mensaje. Inténtalo de nuevo.",
      toastRequired: "El asunto y el mensaje son obligatorios.",
      toastCopied: "Clave pública PGP copiada al portapapeles.",
      toastCopyErr: "No se pudo copiar la clave.",
    },
    footer: {
      noticeTitle: "Aviso de Seguridad",
      notice: "Este sitio no instala rastreadores ni registra direcciones IP. Para navegar con máxima discreción, se recomienda el uso de Tor Browser o una VPN de confianza. La prudencia del lector es la primera línea de defensa de este proyecto.",
      rights: "· Todos los derechos reservados bajo seudónimo",
    },
    admin: {
      access: "Acceso del Autor", desk: "Escritorio del Autor", titleLogin: "Entrada discreta", titleDesk: "Publicar en la bitácora",
      descLogin: "Sólo el autor conoce estas llaves. Sin nombre visible, sin registro público.",
      descDesk: "Redacta y publica un escrito nuevo. Aparecerá de inmediato en la bitácora y en la sección de Instagram.",
      user: "Usuario del autor", pass: "Contraseña", enter: "Entrar al escritorio", checking: "Verificando…",
      welcome: "Bienvenido, Javier. La pluma es tuya.", postTitle: "Título del escrito", postExcerpt: "Extracto breve (opcional)",
      postBody: "Escribe aquí. Separa los párrafos con una línea en blanco…", publish: "Publicar escrito", publishing: "Publicando…",
      published: "Escritos publicados", none: "Aún no hay escritos tuyos publicados.", logout: "Cerrar sesión",
      logoutToast: "Sesión cerrada. La tinta descansa.", okPublish: "Escrito publicado en la bitácora.",
      errRequired: "El título y el texto son obligatorios.", errPublish: "No se pudo publicar el escrito.",
      errDelete: "No se pudo eliminar.", deleted: "Escrito eliminado.", errLogin: "No se pudo iniciar sesión.",
    },
  },
  en: {
    nav: { books: "Books", manifesto: "Manifesto", blog: "Logbook", channels: "Secret Channels", cta: "Encrypted Contact", instagram: "Instagram" },
    hero: { overline: "Writer · Clandestine · Chronicler of the shadows", cta1: "Explore the Work", cta2: "Read the Logbook", scroll: "Scroll down" },
    books: {
      overline: "Published Works", headingA: "The Whole", headingB: "Truth",
      intro: "All three titles in the saga are now on sale on Amazon, available worldwide. Scan each book's QR code and start reading today.",
      amazon: "Buy on Amazon", fragment: "Read excerpt", synopsis: "Read full synopsis",
      scanQr: "Scan the code and buy on Amazon",
      reserved: "Reserved space", reservedSub: "Coming soon",
      modalTag: "A work by Javier Alagrande", fragmentTag: "Excerpt · Free reading", synopsisTag: "Synopsis · Free reading",
      edition: "Clandestine edition", sign: "J. Alagrande",
    },
    manifesto: {
      overline: "Manifesto", headingA: "Writing is an act of", headingB: "resistance",
      intro: "Three chapters, three convictions. What this pen name stands for every time the typewriter wakes at midnight.",
    },
    blog: {
      overline: "Logbook · Fortnightly publication", headingA: "Notes from the", headingB: "Underground",
      intro: "Every two weeks, an entry. Chronicle, confession or smoke — always true in its own way.",
      readMore: "Read full article", archive: "Archive 2026",
    },
    instagram: {
      overline: "Daily publications", headingA: "The Writer's", headingB: "Instagram",
      intro: "Every day, a new piece: fragments, verdicts and notes from the underground, published first on Instagram.",
      follow: "Follow @alagrandejavier", placeholder: "Daily publication", placeholderSub: "The next piece will appear here", view: "View on Instagram",
    },
    contact: {
      overline: "Secret Channels · Information Drop Box", headingA: "Secure", headingB: "Contact",
      intro: "If you hold sensitive information, a story to tell, or simply words that don't fit in public: this is the channel. End-to-end encrypted, no intermediaries.",
      secure: "Encrypted transmission · AES-256", subject: "Subject", subjectPh: "Reason for this communication…",
      message: "Encrypted message", messagePh: "Write here. The content will be encrypted before leaving your browser…",
      anonA: "Send", anonB: "100% anonymously", anonSub: "No name, no email, no identifiers. Only the message.",
      submit: "Encrypt and send message", encrypting: "Encrypting message…",
      channelsTitle: "Secure addresses and channels", proton: "Encrypted email · ProtonMail", telegram: "Telegram channel",
      pgp: "PGP public key", copy: "Copy key",
      note: "For highly sensitive information, prefer Session or PGP-encrypted email. Never include data that could compromise third parties without their consent.",
      toastOk: "Message encrypted and deposited in the secure drop box.",
      toastOkAnon: "Sent 100% anonymously. No trace, no identity record.",
      toastOkNamed: "The author will reply through the channel you indicate.",
      toastErr: "The message could not be delivered. Please try again.",
      toastRequired: "Subject and message are required.",
      toastCopied: "PGP public key copied to clipboard.",
      toastCopyErr: "The key could not be copied.",
    },
    footer: {
      noticeTitle: "Security Notice",
      notice: "This site installs no trackers and records no IP addresses. For maximum discretion, browsing via Tor Browser or a trusted VPN is recommended. The reader's prudence is this project's first line of defense.",
      rights: "· All rights reserved under a pen name",
    },
    admin: {
      access: "Author Access", desk: "Author's Desk", titleLogin: "Discreet entrance", titleDesk: "Publish to the logbook",
      descLogin: "Only the author holds these keys. No visible name, no public record.",
      descDesk: "Write and publish a new piece. It will appear immediately in the logbook and the Instagram section.",
      user: "Author username", pass: "Password", enter: "Enter the desk", checking: "Verifying…",
      welcome: "Welcome, Javier. The pen is yours.", postTitle: "Piece title", postExcerpt: "Short excerpt (optional)",
      postBody: "Write here. Separate paragraphs with a blank line…", publish: "Publish piece", publishing: "Publishing…",
      published: "Published pieces", none: "You have no published pieces yet.", logout: "Log out",
      logoutToast: "Session closed. The ink rests.", okPublish: "Piece published to the logbook.",
      errRequired: "Title and text are required.", errPublish: "The piece could not be published.",
      errDelete: "Could not delete.", deleted: "Piece deleted.", errLogin: "Could not sign in.",
    },
  },
  pt: {
    nav: { books: "Livros", manifesto: "Manifesto", blog: "Diário de bordo", channels: "Canais Secretos", cta: "Contato Cifrado", instagram: "Instagram" },
    hero: { overline: "Escritor · Clandestino · Cronista da sombra", cta1: "Explorar a Obra", cta2: "Ler o Diário", scroll: "Rolar" },
    books: {
      overline: "Obras Publicadas", headingA: "Toda a", headingB: "Verdade",
      intro: "Os três títulos da saga já estão à venda na Amazon, disponíveis no mundo todo. Escaneie o código QR de cada livro e comece a ler hoje.",
      amazon: "Comprar na Amazon", fragment: "Ler fragmento", synopsis: "Ler sinopse completa",
      scanQr: "Escaneie o código e compre na Amazon",
      reserved: "Espaço reservado", reservedSub: "Próxima publicação",
      modalTag: "Obra de Javier Alagrande", fragmentTag: "Fragmento · Leitura livre", synopsisTag: "Sinopse · Leitura livre",
      edition: "Edição clandestina", sign: "J. Alagrande",
    },
    manifesto: {
      overline: "Manifesto", headingA: "Escrever é um ato de", headingB: "resistência",
      intro: "Três capítulos, três convicções. O que este pseudônimo defende cada vez que a máquina de escrever acorda à meia-noite.",
    },
    blog: {
      overline: "Diário de bordo · Publicação quinzenal", headingA: "Notas desde a", headingB: "Clandestinidade",
      intro: "A cada quinze dias, uma entrada. Crônica, confissão ou fumaça — sempre verdade à sua maneira.",
      readMore: "Ler artigo completo", archive: "Arquivo 2026",
    },
    instagram: {
      overline: "Publicações diárias", headingA: "Instagram do", headingB: "Escritor",
      intro: "Cada dia, um novo escrito: fragmentos, sentenças e notas desde a clandestinidade, publicados primeiro no Instagram.",
      follow: "Seguir @alagrandejavier", placeholder: "Publicação diária", placeholderSub: "O próximo escrito aparecerá aqui", view: "Ver no Instagram",
    },
    contact: {
      overline: "Canais Secretos · Caixa de Informação", headingA: "Contato", headingB: "Seguro",
      intro: "Se você tem informação sensível, uma história para contar ou simplesmente palavras que não cabem em público: este é o canal. Criptografia de ponta a ponta, sem intermediários.",
      secure: "Transmissão cifrada · AES-256", subject: "Assunto", subjectPh: "Motivo da comunicação…",
      message: "Mensagem criptografada", messagePh: "Escreva aqui. O conteúdo será cifrado antes de sair do seu navegador…",
      anonA: "Enviar de forma", anonB: "100% anônima", anonSub: "Sem nome, sem e-mail, sem identificadores. Apenas a mensagem.",
      submit: "Cifrar e enviar mensagem", encrypting: "Cifrando mensagem…",
      channelsTitle: "Endereços e canais seguros", proton: "E-mail cifrado · ProtonMail", telegram: "Canal de Telegram",
      pgp: "Chave pública PGP", copy: "Copiar chave",
      note: "Para informações de máxima sensibilidade, prefira Session ou e-mail cifrado com PGP. Nunca inclua dados que possam comprometer terceiros sem seu consentimento.",
      toastOk: "Mensagem cifrada e depositada na caixa segura.",
      toastOkAnon: "Enviado de forma 100% anônima. Sem rastro, sem registro de identidade.",
      toastOkNamed: "O autor responderá pelo canal que você indicar.",
      toastErr: "Não foi possível entregar a mensagem. Tente novamente.",
      toastRequired: "O assunto e a mensagem são obrigatórios.",
      toastCopied: "Chave pública PGP copiada.",
      toastCopyErr: "Não foi possível copiar a chave.",
    },
    footer: {
      noticeTitle: "Aviso de Segurança",
      notice: "Este site não instala rastreadores nem registra endereços IP. Para navegar com máxima discrição, recomenda-se o uso de Tor Browser ou uma VPN de confiança. A prudência do leitor é a primeira linha de defesa deste projeto.",
      rights: "· Todos os direitos reservados sob pseudônimo",
    },
    admin: {
      access: "Acesso do Autor", desk: "Escrivaninha do Autor", titleLogin: "Entrada discreta", titleDesk: "Publicar no diário",
      descLogin: "Só o autor conhece estas chaves. Sem nome visível, sem registro público.",
      descDesk: "Redija e publique um novo escrito. Ele aparecerá de imediato no diário e na seção de Instagram.",
      user: "Usuário do autor", pass: "Senha", enter: "Entrar na escrivaninha", checking: "Verificando…",
      welcome: "Bem-vindo, Javier. A pena é sua.", postTitle: "Título do escrito", postExcerpt: "Extrato breve (opcional)",
      postBody: "Escreva aqui. Separe os parágrafos com uma linha em branco…", publish: "Publicar escrito", publishing: "Publicando…",
      published: "Escritos publicados", none: "Ainda não há escritos seus publicados.", logout: "Sair",
      logoutToast: "Sessão encerrada. A tinta descansa.", okPublish: "Escrito publicado no diário.",
      errRequired: "O título e o texto são obrigatórios.", errPublish: "Não foi possível publicar o escrito.",
      errDelete: "Não foi possível eliminar.", deleted: "Escrito eliminado.", errLogin: "Não foi possível entrar.",
    },
  },
  fr: {
    nav: { books: "Livres", manifesto: "Manifeste", blog: "Journal de bord", channels: "Canaux Secrets", cta: "Contact Chiffré", instagram: "Instagram" },
    hero: { overline: "Écrivain · Clandestin · Chroniqueur de l'ombre", cta1: "Explorer l'Œuvre", cta2: "Lire le Journal", scroll: "Défiler" },
    books: {
      overline: "Œuvres Publiées", headingA: "Toute la", headingB: "Vérité",
      intro: "Les trois titres de la saga sont désormais en vente sur Amazon, disponibles dans le monde entier. Scannez le code QR de chaque livre et commencez à lire aujourd'hui.",
      amazon: "Acheter sur Amazon", fragment: "Lire un extrait", synopsis: "Lire le synopsis complet",
      scanQr: "Scannez le code et achetez sur Amazon",
      reserved: "Espace réservé", reservedSub: "Prochaine publication",
      modalTag: "Une œuvre de Javier Alagrande", fragmentTag: "Extrait · Lecture libre", synopsisTag: "Synopsis · Lecture libre",
      edition: "Édition clandestine", sign: "J. Alagrande",
    },
    manifesto: {
      overline: "Manifeste", headingA: "Écrire est un acte de", headingB: "résistance",
      intro: "Trois chapitres, trois convictions. Ce que ce pseudonyme défend chaque fois que la machine à écrire s'éveille à minuit.",
    },
    blog: {
      overline: "Journal de bord · Publication bimensuelle", headingA: "Notes depuis la", headingB: "Clandestinité",
      intro: "Tous les quinze jours, une entrée. Chronique, confession ou fumée — toujours vraie à sa manière.",
      readMore: "Lire l'article complet", archive: "Archives 2026",
    },
    instagram: {
      overline: "Publications quotidiennes", headingA: "Instagram de", headingB: "l'Écrivain",
      intro: "Chaque jour, un nouvel écrit : fragments, sentences et notes depuis la clandestinité, publiés d'abord sur Instagram.",
      follow: "Suivre @alagrandejavier", placeholder: "Publication quotidienne", placeholderSub: "Le prochain écrit apparaîtra ici", view: "Voir sur Instagram",
    },
    contact: {
      overline: "Canaux Secrets · Boîte à Informations", headingA: "Contact", headingB: "Sécurisé",
      intro: "Si vous détenez des informations sensibles, une histoire à raconter ou simplement des mots qui n'ont pas leur place en public : voici le canal. Chiffrement de bout en bout, sans intermédiaires.",
      secure: "Transmission chiffrée · AES-256", subject: "Objet", subjectPh: "Motif de la communication…",
      message: "Message chiffré", messagePh: "Écrivez ici. Le contenu sera chiffré avant de quitter votre navigateur…",
      anonA: "Envoyer de manière", anonB: "100 % anonyme", anonSub: "Ni nom, ni e-mail, ni identifiants. Seulement le message.",
      submit: "Chiffrer et envoyer", encrypting: "Chiffrement du message…",
      channelsTitle: "Adresses et canaux sécurisés", proton: "E-mail chiffré · ProtonMail", telegram: "Canal Telegram",
      pgp: "Clé publique PGP", copy: "Copier la clé",
      note: "Pour les informations hautement sensibles, préférez Session ou l'e-mail chiffré PGP. N'incluez jamais de données pouvant compromettre des tiers sans leur consentement.",
      toastOk: "Message chiffré et déposé dans la boîte sécurisée.",
      toastOkAnon: "Envoyé de manière 100 % anonyme. Sans trace, sans registre d'identité.",
      toastOkNamed: "L'auteur répondra par le canal que vous indiquerez.",
      toastErr: "Le message n'a pas pu être remis. Réessayez.",
      toastRequired: "L'objet et le message sont obligatoires.",
      toastCopied: "Clé publique PGP copiée.",
      toastCopyErr: "Impossible de copier la clé.",
    },
    footer: {
      noticeTitle: "Avis de Sécurité",
      notice: "Ce site n'installe aucun traceur et n'enregistre aucune adresse IP. Pour naviguer avec une discrétion maximale, l'usage de Tor Browser ou d'un VPN de confiance est recommandé. La prudence du lecteur est la première ligne de défense de ce projet.",
      rights: "· Tous droits réservés sous pseudonyme",
    },
    admin: {
      access: "Accès de l'Auteur", desk: "Bureau de l'Auteur", titleLogin: "Entrée discrète", titleDesk: "Publier dans le journal",
      descLogin: "Seul l'auteur détient ces clés. Aucun nom visible, aucun registre public.",
      descDesk: "Rédigez et publiez un nouvel écrit. Il apparaîtra immédiatement dans le journal et la section Instagram.",
      user: "Identifiant de l'auteur", pass: "Mot de passe", enter: "Entrer au bureau", checking: "Vérification…",
      welcome: "Bienvenue, Javier. La plume est à vous.", postTitle: "Titre de l'écrit", postExcerpt: "Extrait bref (optionnel)",
      postBody: "Écrivez ici. Séparez les paragraphes par une ligne blanche…", publish: "Publier l'écrit", publishing: "Publication…",
      published: "Écrits publiés", none: "Vous n'avez encore aucun écrit publié.", logout: "Se déconnecter",
      logoutToast: "Session fermée. L'encre se repose.", okPublish: "Écrit publié dans le journal.",
      errRequired: "Le titre et le texte sont obligatoires.", errPublish: "Impossible de publier l'écrit.",
      errDelete: "Impossible de supprimer.", deleted: "Écrit supprimé.", errLogin: "Connexion impossible.",
    },
  },
};
